import { Reducer } from "redux";
import {
  REQUEST,
  REQUEST_SUCCESS,
  REQUEST_FAILURE,
  CLEAR_SPECIFIC_REQUEST,
  CLEAR_REQUEST,
} from "./actionType";

export type RequestState = {
  isLoading: boolean;
  didSucceed: boolean;
  didFail: boolean;
  response: object | null;
  error: string | Error;
  request?: any;
};

export const initialState = {};

export type RequestStore = { [key: string]: RequestState };

const reducer: Reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case REQUEST:
      return {
        ...state,
        [payload.type]: {
          isLoading: true,
          didSucceed: false,
          didFail: false,
          response: null,
          error: "",
          request: payload.payload,
        },
      };
    case REQUEST_SUCCESS:
      return {
        ...state,
        [payload.type]: {
          isLoading: false,
          didSucceed: true,
          didFail: false,
          response: payload.response,
          error: "",
        },
      };
    case REQUEST_FAILURE:
      return {
        ...state,
        [payload.type]: {
          isLoading: false,
          didSucceed: false,
          didFail: true,
          response: null,
          error: payload.error,
        },
      };
    case CLEAR_SPECIFIC_REQUEST:
      return {
        ...state,
        [payload.type]: {
          isLoading: false,
          didSucceed: false,
          didFail: false,
          response: null,
          error: "",
        },
      };
    case CLEAR_REQUEST:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
